// services/slotAuthService.js

class SlotAuthService {
  constructor() {
    this.token = null;
    this.refreshToken = null;
    this.refreshPromise = null;
  }

  setTokens(token, refreshToken) {
    this.token = token;
    this.refreshToken = refreshToken;

    sessionStorage.setItem("interviewAuthToken", token);
    sessionStorage.setItem("interviewRefreshToken", refreshToken);
  }

  getToken() {
    if (!this.token) {
      this.token = sessionStorage.getItem("interviewAuthToken")||sessionStorage.getItem("authToken");
    }
    return this.token;
  
  }

  getRefreshToken() {
    if (!this.refreshToken) {
      this.refreshToken = sessionStorage.getItem("interviewRefreshToken")||sessionStorage.getItem("refreshToken");
    }
    return this.refreshToken;
  }

  clearTokens() {
    this.token = null;
    this.refreshToken = null;

    sessionStorage.removeItem("interviewAuthToken");
    sessionStorage.removeItem("interviewRefreshToken");
     sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("refreshToken");
  }

  async refreshAccessToken() {
    // Prevent multiple refresh calls
    if (this.refreshPromise) {
      return this.refreshPromise;
    }

    const refreshToken = this.getRefreshToken();

    if (!refreshToken) {
      throw new Error("No refresh token found.");
    }

    this.refreshPromise = (async () => {
      try {
        const response = await fetch(
          "https://solicitor-api-ns.azurewebsites.net/auth/api/v1/Authentication/slot-book/refresh",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
            },
            body: JSON.stringify({
              refresh_token: refreshToken,
            }),
          },
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data?.message ||
              data?.detail ||
              data?.error ||
              "Unable to refresh token",
          );
        }

        // Adjust these if API returns different names
        const accessToken = data.access_token || data.accessToken || data.token;

        const newRefreshToken =
          data.refresh_token || data.refreshToken || refreshToken;

        this.setTokens(accessToken, newRefreshToken);

        return accessToken;
      } catch (err) {
        this.clearTokens();
        throw err;
      } finally {
        this.refreshPromise = null;
      }
    })();

    return this.refreshPromise;
  }

  async makeAuthenticatedRequest(url, options = {}) {
    let token = this.getToken();

    const makeRequest = (accessToken) =>
      fetch(url, {
        ...options,
        headers: {
          accept: "application/json",
          ...(options.headers || {}),
          ...(accessToken
            ? {
                Authorization: `Bearer ${accessToken}`,
              }
            : {}),
        },
      });

    let response = await makeRequest(token);

    // Retry once after refresh
    if (response.status === 401) {
      token = await this.refreshAccessToken();
      response = await makeRequest(token);
    }

    return response;
  }

  initialize() {
    this.token =
      sessionStorage.getItem("interviewAuthToken") ||
      sessionStorage.getItem("authToken");
    this.refreshToken =
      sessionStorage.getItem("interviewRefreshToken") ||
      sessionStorage.getItem("refreshToken");
  }
}

const slotAuthService = new SlotAuthService();

slotAuthService.initialize();

export default slotAuthService;
